import Vue from 'vue'
import api from 'api'

const state = {
    defaultResultsData: {
        userData: {
            'criterias': [],
            'critics': []
        },
        groupData: {
            'criterias': [],
            'critics': []
        },
        criterias:  {
            'labels': [],
            'texts': []
        },
        critics: []
    },
    results: {
        userData: {
            'criterias': [],
            'critics': []
        },
        groupData: {
            'criterias': [],
            'critics': []
        },
        criterias:  {
            'labels': [],
            'texts': []
        },
        critics: []
    },
    satisfaction: {
        userData: {
            'APPRECIATION': [],
            'YES_NO': []
        },
        groupData: {
            'APPRECIATION': [],
            'YES_NO': []
        },
        questions:  {
            'APPRECIATION': [],
            'YES_NO': []
        }
    },
    modalStatistics: false
};

const getters = {
};

const mutations = {
    RESULTS_STATISTICS_UPDATED(state, {userData, groupData, criterias, critics})  {
        state.results.userData = userData;
        state.results.groupData = groupData;
        state.results.criterias = criterias;
        state.results.critics = critics;
    },
    SATISFACTION_STATISTICS_UPDATED(state, satisfactionData)  {
        state.satisfaction = satisfactionData;
    },
    DISPLAY_MODAL_STATISTICS(state, newValue) {
        state.modalStatistics = newValue;
    }
};

const actions = {
    getInstanceResultsStatistics({rootState}, {instanceId, mode, callbacks})    {
        api.getInstanceResultsStatistics(rootState, instanceId, mode, callbacks);
    },
    getInstanceSatisfactionStatistics({rootState}, {instanceId, mode, callbacks})   {
        api.getInstanceSatisfactionStatistics(rootState, instanceId, mode, callbacks);
    },
    getSessionResultsStatistics({rootState}, {parentTargetInstanceId, callbacks})  {
        api.getParentTargetInstanceResultsStatistics(rootState, parentTargetInstanceId, callbacks);
    },
    getSessionSatisfactionStatistics({rootState}, {parentTargetInstanceId, callbacks}) {
        api.getParentTargetInstanceSatisfactionStatistics(rootState, parentTargetInstanceId, callbacks);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
